<div *ngIf="!hasBeenDismissed" [ngStyle]="{ top: containerTop, left: containerLeft }" class="splash-screen-positioner text-align-left">
	<div class="splash-screen-container padding-10">
		<div class="text-bold" [dcrHTMLKey]="featureKey + '_TITLE'">New Feature!</div>
		<div class="text-14 margin-top-10 padding-bottom-30" [dcrHTMLKey]="featureKey + '_DESCRIPTION'">
			<span>{{ featureKey + '_DESCRIPTION' }}</span>
		</div>
		<button (click)="dismiss($event)" class="text-bold dismiss-button ac-text-button"><icon type="times"></icon><span dcrHTMLKey="NEW_FEATURE_DISMISS">Dismiss</span></button>
		<div class="triangle-right" [ngStyle]="{ top: triangleTop }">
			<div class="inner-triangle-right"></div>
		</div>
	</div>
</div>
